import http from "../../http-common";
import authHeader from "../../services/authHeader";
import { LEAD_API } from "../../api";

export const getLeads = () => {
    return http.get(`${LEAD_API}`, {
        headers: authHeader(),
    });
}

export const updateLead = (data)=>{
    return http.put(`${LEAD_API}`,data, {
        headers: authHeader()
    });
}

export const getRegistrationReport = () => {
    return http.get(`${LEAD_API}/registration/1`, {
        headers: authHeader(),
    });
}

export const getCandidateCreatedBy = (data) => {
    return http.post(`${LEAD_API}/profile-created-by/1`,{passportNos:data}, {
        headers: authHeader(),
    });
}
